export const TXTCLI_Month = {
  "id": "TXTCLI_Month",
  "defaultMessage": "Month"
} as const;

export const TXTCLI_Year = {
  "id": "TXTCLI_Year",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Year"
} as const;

export const TXTCLI_LoadingXX = {
  "id": "TXTCLI_LoadingXX",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Loading..."
} as const;

export const TXTCLI_Close = {
  "id": "TXTCLI_Close",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Close"
} as const;

export const TXTCLI_Table_Size = {
  "id": "TXTCLI_Table_Size",
  "defaultMessage": "Table Size"
} as const;

export const TXTCLI_2_seat_table_XHeads_upX = {
  "id": "TXTCLI_2_seat_table_XHeads_upX",
  "defaultMessage": "2 seat table (Heads-up)"
} as const;

export const TXTCLI_N0_seat_table = {
  "id": "TXTCLI_N0_seat_table",
  "defaultMessage": "{0} seat table"
} as const;

export const TXTCLI_Game_Speed = {
  "id": "TXTCLI_Game_Speed",
  "defaultMessage": "Game Speed"
} as const;

export const TXTCLI_Team_PokerStars_player = {
  "id": "TXTCLI_Team_PokerStars_player",
  "defaultMessage": "Team PokerStars player"
} as const;

export const TXTCLI_Hyper_Turbo = {
  "id": "TXTCLI_Hyper_Turbo",
  "defaultMessage": "Hyper-Turbo"
} as const;

export const TXTCLI_Regular = {
  "id": "TXTCLI_Regular",
  "defaultMessage": "Regular"
} as const;

export const TXTCLI_Slow = {
  "id": "TXTCLI_Slow",
  "defaultMessage": "Slow"
} as const;

export const TXTCLI_Turbo = {
  "id": "TXTCLI_Turbo",
  "defaultMessage": "Turbo"
} as const;

export const TXTCLI_Currencies = {
  "id": "TXTCLI_Currencies",
  "defaultMessage": "Currencies"
} as const;

export const TXTCLI_CurrTitle_USD = {
  "id": "TXTCLI_CurrTitle_USD",
  "defaultMessage": "US Dollars"
} as const;

export const TXTCLI_CurrTitle_GBP = {
  "id": "TXTCLI_CurrTitle_GBP",
  "defaultMessage": "British Pounds"
} as const;

export const TXTCLI_CurrTitle_EUR = {
  "id": "TXTCLI_CurrTitle_EUR",
  "defaultMessage": "Euro"
} as const;

export const TXTCLI_CurrTitle_CAD = {
  "id": "TXTCLI_CurrTitle_CAD",
  "defaultMessage": "Canadian Dollars"
} as const;

export const TXTCLI_Game_types = {
  "id": "TXTCLI_Game_types",
  "defaultMessage": "Game types"
} as const;

export const TXTCLI_Progressive_Knockout = {
  "id": "TXTCLI_Progressive_Knockout",
  "defaultMessage": "Progressive Knockout"
} as const;

export const TXTCLI_Zoom = {
  "id": "TXTCLI_Zoom",
  "defaultMessage": "Zoom"
} as const;

export const TXTCLI_Total_Progressive_Knockout = {
  "id": "TXTCLI_Total_Progressive_Knockout",
  "defaultMessage": "Total Progressive Knockout"
} as const;

export const TXTCLI_HoldXem = {
  "id": "TXTCLI_HoldXem",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Hold'em"
} as const;

export const TXTCLI_Mystery_Bounty_Tournament = {
  "id": "TXTCLI_Mystery_Bounty_Tournament",
  "defaultMessage": "Mystery Bounty Tournament"
} as const;

export const TXTCLI_Team_PokerStars_Bounty = {
  "id": "TXTCLI_Team_PokerStars_Bounty",
  "defaultMessage": "Team Pro Bounty"
} as const;